/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleButton({ testid = "google-signin-button", label = "Continue with Google" }) {
  const onClick = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full inline-flex items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-900 hover:bg-slate-50 hover:border-slate-300 transition-all"
      data-testid={testid}
    >
      <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#EA4335"
          d="M12 10.2v3.9h5.5c-.24 1.4-1.62 4.1-5.5 4.1-3.3 0-6-2.7-6-6s2.7-6 6-6c1.88 0 3.14.8 3.86 1.48l2.64-2.54C16.9 3.6 14.7 2.7 12 2.7c-5.13 0-9.3 4.17-9.3 9.3s4.17 9.3 9.3 9.3c5.36 0 8.92-3.77 8.92-9.08 0-.6-.06-1.06-.14-1.52H12z"
        />
      </svg>
      {label}
    </button>
  );
}
